import React from "react";
import { OutlinedInput, Typography } from "@mui/material";
import { useController } from "react-hook-form";

import { StyledFormControl } from "../../components/HubHookFormInput/styles";

const ConvertedMinutesInput = ({
  name,
  divisor = 60,
  endAdornmentText = "hrs",
  defaultValue = 0,
  required = false,
  shouldUnregister = false,
  formControlProps = {},
}) => {
  const {
    field: { value, onChange, onBlur, ref, name: inputName },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
    shouldUnregister,
    rules: {
      validate: required
        ? (val) =>
            (val !== null && val !== undefined && val !== "") ||
            "This field is required"
        : undefined,
    },
  });

  const display =
    value === null || value === undefined || value === ""
      ? ""
      : Number((Number(value) / divisor).toFixed(2)).toString();

  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "") return onChange(null);
    const num = parseFloat(raw);
    if (Number.isNaN(num)) return;
    onChange(Math.round(num * divisor));
  };

  return (
    <StyledFormControl fullWidth {...formControlProps}>
      <OutlinedInput
        size="small"
        type="number"
        inputProps={{ step: "0.01", min: 0 }}
        value={display}
        onChange={handleChange}
        onBlur={onBlur}
        inputRef={ref}
        name={inputName}
        error={!!error}
        endAdornment={
          <Typography variant="inputAdornment">{endAdornmentText}</Typography>
        }
      />
    </StyledFormControl>
  );
};

export default ConvertedMinutesInput;
